import AppModalContainer from '@nxsys/components/AppModalContainer';
import PensionContributionReport from '../../reports/pension/listing/PensionContributionReport';
import React from 'react';
import styled from 'styled-components';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

type Props = {
  isOpen: boolean;
  toggle: () => void;
};

const AllPensionModal: React.FC<Props> = ({ isOpen, toggle }) => {
  return (
    <AppModalContainer
      title={null}
      width={1200}
      isOpen={isOpen}
      toggle={toggle}
      className="max-sm:w-[100vw]"
      minHeight="0"
      noPaddingBody
      titleFullWidth
      hiddenFooter
    >
      <StyledContentContainer>
        <PensionContributionReport isDashboard />
      </StyledContentContainer>
    </AppModalContainer>
  );
};

const StyledContentContainer = styled.div`
  padding-top: 10px;

  > div > div:nth-child(2) {
    background-color: ${defaultTheme.theme.palette.white};
    min-height: 200px;
    height: fit-content;

    > div > div > div {
      background-color: ${defaultTheme.theme.palette.white};
    }
  }
`;

export default AllPensionModal;
